module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9da6513dc1123d401f7988476d6cfe12.png";